import { CustomerHeader } from "./header";

export function NotFoundPage({ type = "page" }: { type?: string }) {
  return (
    <div className="event-overlay">
      <CustomerHeader />
      <div className="not-found-page">
        <h5>OOPS!!!!</h5>
        <h2>This {type} does not exist!</h2>
        <h6>Kindly check the {type} url.</h6>
      </div>
    </div>
  );
}
